import { Disclosure } from 'anf-core-react';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

function ListItemDisclosure({
  children,
  id,
  isDefaultExpanded = false,
  label,
}) {
  const [isExpanded, setIsExpanded] = useState(isDefaultExpanded);
  const clickHandler = () => setIsExpanded(!isExpanded);
  return (
    <Disclosure
      id={id}
      isExpanded={isExpanded}
      label={label}
      onClick={clickHandler}
    >
      {children}
    </Disclosure>
  );
}

export default ListItemDisclosure;

ListItemDisclosure.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  isDefaultExpanded: PropTypes.bool,
  label: PropTypes.node.isRequired,
};
